<template>
  <TsCarouselV2 :items-to-show="items"
            :wrap-around="wrap"
            :autoplay
            :pagination
            :navigation
            v-bind="$attrs"
            :class="$attrs.class || twMerge('relative', props.appendClass)"
            :id="'swiper-' + random_id"
            @slide-start="emit('clickComponent')"
  >
    <slot>
      <TsCarouselSlide
          v-for="(slide, index) in slides"
          :key="'swiper-slide' + random_id + index"
          class="w-full"
      >
        <Blocks
            v-if="props.builderBlock"
            class="w-full"
            :parent="props.builderBlock.id"
            :path="`component.options.slides.${index}.content`"
            :blocks="slide.content"
        />
      </TsCarouselSlide>
    </slot>
  </TsCarouselV2>
</template>

<script setup lang="ts">
import {twMerge, type ClassNameValue} from "tailwind-merge";
import { Blocks } from '@builder.io/sdk-vue';

const TsCarouselV2 = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselV2.vue')
);

const TsCarouselSlide = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSlide.vue')
);

const random_id = ref('')

onMounted(() => {
  random_id.value = useRandomUUID()
})

const emit = defineEmits(['clickComponent'])

type Props = {
  builderBlock?: object
  slides?: object[]
  wrap?: boolean
  navigation?: boolean
  pagination?: boolean
  items?: number
  autoplay?: boolean
  appendClass?: ClassNameValue;
}
const props = withDefaults(defineProps<Props>(), {
  wrap: false,
  navigation: false,
  pagination: false,
  slides: () => [],
  autoplay: false,
  appendClass: "",
});
</script>
